import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import store from "./store";
import { Provider } from "react-redux";
import * as serviceWorker from "./serviceWorker";

import { GoogleOAuthProvider } from '@react-oauth/google';

ReactDOM.render(
    <Provider store={store}>
      <GoogleOAuthProvider clientId="813129216730-60f238e91dudje60vmv1lommtjd7p8fu.apps.googleusercontent.com">
        <App />
      </GoogleOAuthProvider>
    </Provider>,
  document.querySelector("#root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
